"use client";

// Deprecated combined navigation file. Header & Footer moved to dedicated components.
// This file now only exports the navigation items array for reuse.

const navigation = [
  { name: "Concretta", href: "/concretta" },
  { name: "About", href: "/about" },
  { name: "Reviews", href: "/reviews" },
  { name: "Contact", href: "/contact" },
  { name: "Find Applicators", href: "/applicators" },
];

export { navigation };
